<template>
  <div>
    <!-- 修改箱规 -->
    <el-dialog :title="$t('message.modifyBoxRules')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="780px" center>
      <div class="content">

        <div class="table">
          <ol>
            <!-- 箱型 -->
            <li class="flex15">
              {{ $t("message.boxPile") }}
            </li>
            <!-- 长 -->
            <li>
              {{ $t("message.length") }}
            </li>
            <!-- 箱宽型 -->
            <li>
              {{ $t("message.width") }}
            </li>
            <!-- 高 -->
            <li>
              {{ $t("message.height") }}
            </li>
            <!-- 重量 -->
            <li>
              {{ $t("message.weight") }}
            </li>
          </ol>
          <ul>
            <!-- 箱型 -->
            <li class="flex15">
              <el-select v-model="attr" placeholder="请选择" @change="setCWK">
                <el-option v-for="item in attrOption" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </li>
            <!-- 长 -->
            <li>
              <el-input v-model="c" oninput="value=value.replace(/^([0-9]\d*\.?\d{0,3})?.*$/,'$1')"
                onfocus="this.select()"></el-input>
            </li>
            <!-- 箱宽型 -->
            <li>
              <el-input v-model="k" oninput="value=value.replace(/^([0-9]\d*\.?\d{0,3})?.*$/,'$1')"
                onfocus="this.select()"></el-input>
            </li>
            <!-- 高 -->
            <li>
              <el-input v-model="g" oninput="value=value.replace(/^([0-9]\d*\.?\d{0,3})?.*$/,'$1')"
                onfocus="this.select()"></el-input>
            </li>
            <!-- 重量 -->
            <li>
              <el-input v-model="weight" onfocus="this.select()"
                oninput="value=value.replace(/^([0-9]\d*\.?\d{0,3})?.*$/,'$1')"></el-input>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { attrOption } from "@/utlis/options";
export default {
  props: {
    move_sn: { type: String },
  },
  data() {
    return {
      attrOption,
      attr: "",
      c: 0,
      k: 0,
      g: 0,
      weight: 0,
      dialogVisible: false,
    };
  },
  methods: {
    // 初始化
    init(ids, boxList) {
      if (ids.length > 1) {
        this.attr = "";
        this.c = 0;
        this.k = 0;
        this.g = 0;
        this.weight = 0;
      } else {
        boxList.forEach(item => {
          item.list.forEach(box => {
            if (box.checked) {
              this.attr = box.attr
              this.c = box.c
              this.k = box.k
              this.g = box.g
              this.weight = box.weight
            }
          })
        })
      }
      this.ids = ids;
    },
    // 保存
    save() {
      let datas = {
        ids: this.ids,
        c: this.c,
        k: this.k,
        g: this.g,
        weight: this.weight,
        attr: `${this.c}*${this.k}*${this.g}`,
      };
      this.$api.inventoryTransferApi.updateBoxAttr(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$store.dispatch("transferOrdeBoxList", { move_sn: this.move_sn });
      });
    },
    // 取到长宽高
    setCWK(e) {
      let arr = e.split("*");
      this.c = arr[0];
      this.k = arr[1];
      this.g = arr[2];
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 40px;
    }

    .val {
      flex: 3;
    }
  }

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;
      border: 0;

      li {
        padding: 24px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex15 {
      flex: 1.5;
    }
  }

  /deep/.el-input {
    width: 60%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>